import React, { createContext, useContext, useEffect, useState } from "react";

export const translations = {
  es: {
    nav: {
      history: "Historia",
      mission: "Misión",
      services: "Servicios",
      community: "Compromiso",
      gallery: "Fotos",
      contact: "Contacto",
      cta: "Contáctanos",
    },
    hero: {
      overline: "Associació d'Esclerosi Múltiple del Baix Llobregat",
      title: ["Acompañamos", "cada paso", "hacia una vida", "más plena."],
      subtitle:
        "Desde 1999, en Gavà, mejoramos la calidad de vida de las personas con esclerosis múltiple y enfermedades neuromusculares, junto a sus familias.",
      ctaPrimary: "Conócenos",
      ctaSecondary: "Nuestros servicios",
      badge: "Rambla Vayreda 68 bajos, Gavà, Catalunya",
    },
    marquee: "Compromiso con Gavà · Apoyo integral · Inclusión · Accesibilidad · AEMBAIX ·",
    history: {
      overline: "Nuestra historia",
      title: "Una entidad nacida de la necesidad",
      body: "La Associació d'Esclerosi Múltiple del Baix Llobregat (AEMBAIX) fue inscrita oficialmente en el Registro de Asociaciones de Cataluña el 5 de mayo de 1999. Desde entonces desarrolla su actividad en Gavà con ámbito de actuación en la comarca del Baix Llobregat.",
      body2:
        "Su creación respondió a la necesidad de ofrecer apoyo e información a las personas con esclerosis múltiple y a sus familias en una comarca donde no existía una entidad específica para esta enfermedad.",
      milestones: [
        { year: "1999", label: "Fundación", text: "Inscripción oficial en el Registro de Asociaciones de Cataluña, el 5 de mayo." },
        { year: "Hoy", label: "Presente", text: "Referente de apoyo integral en el Baix Llobregat para personas con EM y otras enfermedades neuromusculares." },
      ],
    },
    mission: {
      overline: "Nuestra misión",
      title: "Mejorar la calidad de vida, cada día",
      intro:
        "AEMBAIX trabaja para mejorar la calidad de vida de las personas afectadas por la esclerosis múltiple y otras enfermedades neuromusculares mediante:",
      items: [
        { n: "01", title: "Información y orientación", text: "Acompañamiento cercano a personas afectadas y a sus familias." },
        { n: "02", title: "Rehabilitación física", text: "Programas terapéuticos adaptados a cada persona." },
        { n: "03", title: "Apoyo psicológico", text: "Espacios de escucha y contención emocional." },
        { n: "04", title: "Actividades terapéuticas", text: "Talleres y terapias grupales que fomentan el bienestar." },
        { n: "05", title: "Inclusión y accesibilidad", text: "Promoción activa de la inclusión social y la accesibilidad." },
      ],
    },
    services: {
      overline: "Servicios y actividades",
      title: "Todo lo que ofrecemos",
      intro: "A lo largo de nuestra trayectoria hemos incorporado servicios diversos, siempre centrados en las personas.",
      list: [
        { name: "Fisioterapia", desc: "Rehabilitación física personalizada." },
        { name: "Psicoterapia", desc: "Apoyo psicológico individual y familiar." },
        { name: "Musicoterapia", desc: "La música como herramienta terapéutica." },
        { name: "Yoga", desc: "Movimiento consciente y bienestar." },
        { name: "Rehabilitación acuática", desc: "Aquaterapia adaptada." },
        { name: "Talleres de manualidades", desc: "Creatividad y motricidad." },
        { name: "Talleres de cocina", desc: "Autonomía y vida saludable." },
        { name: "Terapias grupales", desc: "Compartir y crecer en comunidad." },
        { name: "Salidas adaptadas", desc: "Ocio inclusivo y accesible." },
      ],
      note: "Además, el Ayuntamiento de Gavà ha concedido subvenciones para proyectos concretos de fisioterapia, psicoterapia y aquaterapia, reflejados en el Boletín Oficial de la Provincia de Barcelona.",
    },
    community: {
      overline: "Compromiso con Gavà y el Baix Llobregat",
      title: "Presentes en la vida del municipio",
      body: "Participamos de forma habitual en actividades de sensibilización y en eventos solidarios del municipio.",
      events: ["Sant Jordi", "Día Mundial de la Esclerosis Múltiple", "Semana de la Accesibilidad", "Actividades comunitarias en Gavà"],
      highlight:
        "Celebramos públicamente nuestro 15.º aniversario mediante un festival solidario en el Espai Maragall de Gavà, con actuaciones de música, teatro, danza y cine.",
    },
    openSpace: {
      overline: "Un espacio abierto",
      title: "Un espacio para todos",
      body: "Aunque nacimos para atender a personas con esclerosis múltiple, AEMBAIX también presta apoyo a personas con otras enfermedades neuromusculares que no disponen de asociaciones específicas en su entorno.",
    },
    gallery: {
      overline: "Galería",
      title: "Momentos que nos unen",
      empty: "Galería de fotos (Próximamente)",
      emptyText: "Estamos preparando este espacio para compartir nuestros momentos. Vuelve pronto.",
      photos: [
        { src: "/gallery/foto3.webp", caption: "Rehabilitación con bipedestador" },
        { src: "/gallery/foto2.webp", caption: "Día Internacional de las Personas con Discapacidad" },
        { src: "/gallery/foto1.jpg", caption: "Monólogo solidario · Rotary Club de Gavà" },
        { src: "/gallery/foto6.jpeg", caption: "Salida del grupo de musicoterapia al concierto de la 9ª sinfonía de Beethoven en el Atrium Viladecans" },
        { src: "/gallery/foto5.webp", caption: "Puesto informativo · Día Mundial de la Esclerosis Múltiple" },
        { src: "/gallery/foto4.jpeg", caption: "Actividad al aire libre en Gavà" },
      ],
    },
    funding: {
      overline: "Financiación",
      title: "Cómo nos sostenemos",
      body: "La entidad se sostiene gracias a:",
      sources: [
        { title: "Cuotas de socios", text: "El compromiso de nuestra base social." },
        { title: "Subvenciones públicas", text: "Apoyo de las administraciones." },
        { title: "Donaciones y colaboraciones", text: "De entidades y empresas del territorio." },
      ],
      partnersLabel: "Colaboradores",
      partners: ["Ayuntamiento de Gavà", "CaixaBank", "Rotary Club de Gavà"],
    },
    contact: {
      overline: "Contacto",
      title: "Hablemos",
      body: "¿Tienes dudas, quieres asociarte o colaborar? Escríbenos y te responderemos lo antes posible.",
      phoneLabel: "Teléfono",
      emailLabel: "Correo",
      form: {
        name: "Nombre",
        email: "Correo electrónico",
        phone: "Teléfono (opcional)",
        subject: "Asunto",
        message: "Mensaje",
        submit: "Enviar mensaje",
        sending: "Enviando...",
        success: "¡Gracias! Hemos recibido tu mensaje.",
        error: "No se pudo enviar. Inténtalo de nuevo.",
      },
    },
    footer: {
      tagline: "Associació d'Esclerosi Múltiple del Baix Llobregat",
      rights: "Todos los derechos reservados.",
      location: "Rambla Vayreda 68 bajos, Gavà, Catalunya",
    },
  },

  ca: {
    nav: {
      history: "Història",
      mission: "Missió",
      services: "Serveis",
      community: "Compromís",
      gallery: "Fotos",
      contact: "Contacte",
      cta: "Contacta'ns",
    },
    hero: {
      overline: "Associació d'Esclerosi Múltiple del Baix Llobregat",
      title: ["Acompanyem", "cada pas", "cap a una vida", "més plena."],
      subtitle:
        "Des de 1999, a Gavà, millorem la qualitat de vida de les persones amb esclerosi múltiple i malalties neuromusculars, juntament amb les seves famílies.",
      ctaPrimary: "Coneix-nos",
      ctaSecondary: "Els nostres serveis",
      badge: "Rambla Vayreda 68 baixos, Gavà, Catalunya",
    },
    marquee: "Compromís amb Gavà · Suport integral · Inclusió · Accessibilitat · AEMBAIX ·",
    history: {
      overline: "La nostra història",
      title: "Una entitat nascuda de la necessitat",
      body: "L'Associació d'Esclerosi Múltiple del Baix Llobregat (AEMBAIX) va ser inscrita oficialment al Registre d'Associacions de Catalunya el 5 de maig de 1999. Des de llavors desenvolupa la seva activitat a Gavà amb àmbit d'actuació a la comarca del Baix Llobregat.",
      body2:
        "La seva creació va respondre a la necessitat d'oferir suport i informació a les persones amb esclerosi múltiple i a les seves famílies en una comarca on no existia una entitat específica per a aquesta malaltia.",
      milestones: [
        { year: "1999", label: "Fundació", text: "Inscripció oficial al Registre d'Associacions de Catalunya, el 5 de maig." },
        { year: "Avui", label: "Present", text: "Referent de suport integral al Baix Llobregat per a persones amb EM i altres malalties neuromusculars." },
      ],
    },
    mission: {
      overline: "La nostra missió",
      title: "Millorar la qualitat de vida, cada dia",
      intro:
        "AEMBAIX treballa per millorar la qualitat de vida de les persones afectades per l'esclerosi múltiple i altres malalties neuromusculars mitjançant:",
      items: [
        { n: "01", title: "Informació i orientació", text: "Acompanyament proper a persones afectades i a les seves famílies." },
        { n: "02", title: "Rehabilitació física", text: "Programes terapèutics adaptats a cada persona." },
        { n: "03", title: "Suport psicològic", text: "Espais d'escolta i contenció emocional." },
        { n: "04", title: "Activitats terapèutiques", text: "Tallers i teràpies grupals que fomenten el benestar." },
        { n: "05", title: "Inclusió i accessibilitat", text: "Promoció activa de la inclusió social i l'accessibilitat." },
      ],
    },
    services: {
      overline: "Serveis i activitats",
      title: "Tot el que oferim",
      intro: "Al llarg de la nostra trajectòria hem incorporat serveis diversos, sempre centrats en les persones.",
      list: [
        { name: "Fisioteràpia", desc: "Rehabilitació física personalitzada." },
        { name: "Psicoteràpia", desc: "Suport psicològic individual i familiar." },
        { name: "Musicoteràpia", desc: "La música com a eina terapèutica." },
        { name: "Ioga", desc: "Moviment conscient i benestar." },
        { name: "Rehabilitació aquàtica", desc: "Aquateràpia adaptada." },
        { name: "Tallers de manualitats", desc: "Creativitat i motricitat." },
        { name: "Tallers de cuina", desc: "Autonomia i vida saludable." },
        { name: "Teràpies grupals", desc: "Compartir i créixer en comunitat." },
        { name: "Sortides adaptades", desc: "Oci inclusiu i accessible." },
      ],
      note: "A més, l'Ajuntament de Gavà ha concedit subvencions per a projectes concrets de fisioteràpia, psicoteràpia i aquateràpia, reflectits al Butlletí Oficial de la Província de Barcelona.",
    },
    community: {
      overline: "Compromís amb Gavà i el Baix Llobregat",
      title: "Presents a la vida del municipi",
      body: "Participem de manera habitual en activitats de sensibilització i en esdeveniments solidaris del municipi.",
      events: ["Sant Jordi", "Dia Mundial de l'Esclerosi Múltiple", "Setmana de l'Accessibilitat", "Activitats comunitàries a Gavà"],
      highlight:
        "Vam celebrar públicament el nostre 15è aniversari amb un festival solidari a l'Espai Maragall de Gavà, amb actuacions de música, teatre, dansa i cinema.",
    },
    openSpace: {
      overline: "Un espai obert",
      title: "Un espai per a tothom",
      body: "Encara que vam néixer per atendre persones amb esclerosi múltiple, AEMBAIX també dóna suport a persones amb altres malalties neuromusculars que no disposen d'associacions específiques al seu entorn.",
    },
    gallery: {
      overline: "Galeria",
      title: "Moments que ens uneixen",
      empty: "Galeria de fotos (Properament)",
      emptyText: "Estem preparant aquest espai per compartir els nostres moments. Torna aviat.",
      photos: [
        { src: "/gallery/foto3.webp", caption: "Rehabilitació amb bipedestador" },
        { src: "/gallery/foto2.webp", caption: "Dia Internacional de les Persones amb Discapacitat" },
        { src: "/gallery/foto1.jpg", caption: "Monòleg solidari · Rotary Club de Gavà" },
        { src: "/gallery/foto6.jpeg", caption: "Sortida del grup de musicoteràpia a concert de la 9ª simfonia de Beethoven a Atrium Viladecans" },
        { src: "/gallery/foto5.webp", caption: "Estand informatiu · Dia Mundial de l'Esclerosi Múltiple" },
        { src: "/gallery/foto4.jpeg", caption: "Activitat a l'aire lliure a Gavà" },
      ],
    },
    funding: {
      overline: "Finançament",
      title: "Com ens sostenim",
      body: "L'entitat es sosté gràcies a:",
      sources: [
        { title: "Quotes dels socis", text: "El compromís de la nostra base social." },
        { title: "Subvencions públiques", text: "Suport de les administracions." },
        { title: "Donacions i col·laboracions", text: "D'entitats i empreses del territori." },
      ],
      partnersLabel: "Col·laboradors",
      partners: ["Ajuntament de Gavà", "CaixaBank", "Rotary Club de Gavà"],
    },
    contact: {
      overline: "Contacte",
      title: "Parlem-ne",
      body: "Tens dubtes, vols associar-te o col·laborar? Escriu-nos i et respondrem al més aviat possible.",
      phoneLabel: "Telèfon",
      emailLabel: "Correu",
      form: {
        name: "Nom",
        email: "Correu electrònic",
        phone: "Telèfon (opcional)",
        subject: "Assumpte",
        message: "Missatge",
        submit: "Envia el missatge",
        sending: "Enviant...",
        success: "Gràcies! Hem rebut el teu missatge.",
        error: "No s'ha pogut enviar. Torna-ho a provar.",
      },
    },
    footer: {
      tagline: "Associació d'Esclerosi Múltiple del Baix Llobregat",
      rights: "Tots els drets reservats.",
      location: "Rambla Vayreda 68 baixos, Gavà, Catalunya",
    },
  },
};

export const CONTACT = {
  phone: "+34 665 27 88 60",
  phoneHref: "tel:+34665278860",
  email: "aembaixgava@gmail.com",
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("aembaix_lang") || "es");
  useEffect(() => {
    localStorage.setItem("aembaix_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
